exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/lepetitsalon/wp-content/themes/digitalcover/node_modules/core-js/internals/object-get-own-property-symbols.js
// module id = 69
// module chunks = 0